import { IAction, SET_IS_FETCHING, SET_IS_LOADING } from './consts';

export const baseReducer = (state: any, action: IAction) => {
  switch (action.type) {
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    default:
      return state;
  }
};
